module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-tabletPro-en.d077340b.webp";